"use strict";

var _require = require('@antv/component/lib'),
    Guide = _require.Guide;

var RegionFilter = require('./region-filter');

Guide.RegionFilter = RegionFilter;
module.exports = Guide;


//////////////////
// WEBPACK FOOTER
// ./src/component/guide/index.js
// module id = 359
// module chunks = 0 1 2